module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/arr_vid-5624d21e70836ad5d8af0658056ab24a.svg";